<script>
export default {
  props: {
    company: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<template>
  <div class="homepage_content_div">
    <div class="content_logo hide_on_mobile">
      <img
        :src="company.logoOssUrl || defaultCompanyLogo"
        :alt="company.shortName"
      />
    </div>
    <div class="content_right">
      <div class="name_star">
        <h1 class="content_name pc_owner_h1">{{ company.shortName }}</h1>
        <div v-show="company.evaluateAvg > 0" class="content_star_container">
          <div class="content_star_label">
            口碑：
          </div>
          <no-ssr>
            <star-rating
              :read-only="true"
              :show-rating="false"
              :rating="company.evaluateAvg"
              :star-size="12"
            />
          </no-ssr>
        </div>
      </div>
      <div class="view_statistic hide_on_mobile">
        <div class="statistic_view">
          <div>{{ company.pageViewCount }}</div>
          <div>浏览量</div>
        </div>
        <div class="statistic_project">
          <div>{{ company.workingProjectNum }}</div>
          <div>装修工地</div>
        </div>
        <div v-if="company.evaluateCount != 0" class="statistic_comment">
          <div>{{ company.evaluateCount }}</div>
          <div>业主评价</div>
        </div>
      </div>
      <div class="view_statistic_mobile hide_on_pc">
        <span style="white-space:pre"
          >{{
            `浏览: ${company.pageViewCount}  工地: ${company.workingProjectNum}  `
          }}<span v-if="company.evaluateCount !== 0">{{
            `评价: ${company.evaluateCount}`
          }}</span></span
        >
      </div>
      <div
        v-if="company.phoneNo"
        class="content_line_placeholder line_after_1px hide_on_pc"
      ></div>
      <a :href="`tel:${company.phoneNo}`" class="company_phone">
        <div v-if="company.phoneNo" class=" icon_div">
          <img src="~/assets/image/icon/icon-tel.png" />
          <div>{{ company.phoneNo }}</div>
        </div>
      </a>
      <div
        v-if="company.companyAddress"
        class="content_line_placeholder line_after_1px hide_on_pc"
      ></div>
      <div v-if="company.companyAddress" class="company_address icon_div">
        <img src="~/assets/image/icon/icon-location.png" />
        <div>
          {{ company.companyAddress }}
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
//common
.homepage_content_div {
  display: flex;
  align-items: flex-start;
  //左半部分,公司logo
  .content_logo {
    flex-basis: 25%;
    > img {
      width: 180px;
      height: 180px;
      object-fit: cover;
    }
  }
  //右半部分,公司detail
  .content_right {
    display: flex;
    // flex-basis: 75%;
    flex-direction: column;
    margin-left: 20px;

    //公司名称和口碑评分
    .name_star {
      align-items: center;
      .content_star_container {
        display: flex;
        align-items: center;
        .content_star_label {
          font-size: 14px;
          font-weight: 400;
          line-height: 14px;
        }
      }
    }
    //公司统计数据
    .view_statistic {
      margin-top: 36px;
      > div {
        text-align: center;
        margin-right: 35px;
        //统计数据的数字
        :first-child {
          font-size: 18px;
          font-weight: 500;
          line-height: 18px;
        }
        //统计数据的标签
        :last-child {
          margin-top: 10px;
          height: 14px;
          font-size: 14px;
          font-weight: 400;
          line-height: 14px;
        }
      }
    }
    //公司电话和地址
    .icon_div {
      display: flex;
      align-items: flex-start;
      img {
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
      > div {
        font-size: 14px;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);
        line-height: 19px;
      }
    }
  }
}
//pc only
@media screen and (min-width: 940px) {
  .homepage_content_div {
    //右半部分,公司detail
    .content_right {
      > div {
        display: flex;
      }
      //公司名称和口碑评分
      .name_star {
        .content_star_label {
          margin-left: 15px;
        }
      }

      //公司电话和地址
      .company_phone {
        margin-top: 36px;
      }
      .company_address {
        margin-top: 12px;
        width: 378px;
      }
    }
  }
}
//mobile only
@media screen and (max-width: 940px) {
  .homepage_content {
    width: 100%;
    .homepage_content_div {
      .content_right {
        flex-basis: 100%;
        margin-left: 0;
        .content_star_container {
          margin-top: 15px;
        }
        .view_statistic_mobile {
          margin-top: 15px;
          > span {
            font-size: 14px;
          }
        }
        .content_line_placeholder {
          height: 15px;
        }
        .company_phone {
          margin-top: 15px;
        }
        .company_address {
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
